import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'lodash';
import { Observable } from 'rxjs';
import { filter, map, shareReplay, switchMap } from 'rxjs/operators';

import { AutoUnsubscribe } from 'helpers';
import { ReferralModel } from 'shared/models/referral.model';
import { OrganizationType } from 'shared/services';
import { Referral } from '../../../types';

@AutoUnsubscribe
@Component({
    selector: 'fc-start-referral',
    templateUrl: './start-referral.component.html',
    styleUrls: ['./start-referral.component.less'],
    standalone: false
})
export class StartReferralSignupComponent implements OnInit {
    public referral$: Observable<Referral>;
    private referralId$: Observable<string>;

    constructor(
        private referralModel: ReferralModel,
        private route: ActivatedRoute,
        private router: Router
    ) {}

    ngOnInit(): void {
        this.referralId$ = this.route.paramMap.pipe(map((params) => params.get('referralId')));
        this.referral$ = this.referralId$.pipe(
            switchMap((referralId) => this.referralModel.getReferral(referralId)),
            filter((referral) => !_.isEmpty(referral)),
            map((referral: Referral) => ({
                ...referral,
                brand: {
                    name: _.get(referral, 'brand.name', '')
                }
            })),
            shareReplay()
        );
    }

    goToSignupForm(referral: Referral) {
        return this.router.navigate(['signup', 'referral', 'join'], {
            queryParams: {
                step: 1,
                referralId: referral._id,
                organizationType: OrganizationType.Retailer,
                referralType: referral?.referralType
            },
            queryParamsHandling: 'merge'
        });
    }
}
